import { ElementRef, Injectable, Renderer2, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RendererService {
  private readonly renderer = inject(Renderer2);

  setCSSGlobalVariableForElement(element: ElementRef, variableName: string, variableValue: string): void {
    this.renderer.setStyle(element.nativeElement, variableName, variableValue);
  }
}
